import React from 'react'
import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getAdvertisementDetail} from '../../../apis/advertisement/getAdvertisementDetail'

const useQueryAdvertisementDetail = (id: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.advertisement.getAdvertisementDetail(id),
        queryFn: async () => {
            const {data} = await getAdvertisementDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryAdvertisementDetail
